export const TRANSITION = 1;
